import { render } from "./VideoPlayerInfoPanel.vue?vue&type=template&id=5c40547c&ts=true"
import script from "./VideoPlayerInfoPanel.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerInfoPanel.vue?vue&type=script&lang=ts"

import "./VideoPlayerInfoPanel.vue?vue&type=style&index=0&id=5c40547c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__